import './Reactivations.scss';
import { Col, Row } from "rsuite";
import { CONSTANTS } from "client/utils/constants";
import GetAttachmentView from "client/CommonComponents/AttachmentView";
import { Accordion, Alert, AttachmentCommonUpload, Callout, Card, EventHandler, InputField, Label, OutlineButton, PopupDialogbox, PrimaryButton } from "client/CommonComponents";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import plus from '../../../../../../assets/images/Plus New.svg'
import deleteOrder from '../../../../../../assets/images/Delete New.svg';
import AssetNumber from "client/Components/OrderManagement/AssetNumber";
import { formatPrice, isNumberWithOneDecimal, isNumberWithoutDecimal } from "utils";
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import permissions, { isAuthorized } from 'client/utils/Permissions';
const { ATTACHMENTS_TOOLTIP_CONTENT } = CONSTANTS

const InformativeField = ({ label, value }: any) => (
    <div className="info-wrapper">
        <div className="label">{label}</div>
        <div className="value">{value}</div>
    </div>
);
const Reactivations = (props?: any) => {
    const {
        assetDetailList,
        getLinkedAttachmentsCount,
        WarningPopupcontent,
        Popupcontent,
        hideDialog,
        warningHideDialog,
        setAssetDetailList,
        setIsAsserNumberValid,
        setIsAssetBtnClicked,
        isAssetBtnClicked,
        isAddAssetClicked,
        setIsAddAssetClicked,
        docList,
        onRemoveAttachment,
        attachmentError,
        setAttachmentError,
        onUploadClick,
        documentList,
        setDocumentList,
        onClickAdd,
        addNewAssetAlert,
        hideDialogAsset,
        onClickDelete,
        onClicktLinkAttachment,
        onCloseLinkAttachment,
        isAttachmentBtnClicked,
        onChangeLinkAttachment,
        onChangeOdometerHourMeter,
        onBlurOdometerHourMeter,
        onChangeColor,
        handleLicensePlateChange,
        handleCommentchanges,
        getOdometerLabel,
        getVinSerialLabel,
        onClickAddAsset,
        cartAssets,
        isEditOrder,
        transferOrderByIdData,
        revertChangesOnClick,
        cancelRequestOnClick,
        cancelPopupContent,
        hideCancelDialog,
        showCart,
        reactivationAssets,
        isHourMeterField
    } = props;

    const childItems: any = [];
    assetDetailList?.forEach((asset: any, index: any) => {
        const childItem = {
            headerText: (
                <div className={`heading-container ${asset?.isExist ? 'added-to-cart' : 'not-added-to-cart'}`}>
                    <div className='heading-container-subItem'>
                        <span><b>ITEM # :{asset?.assetIndex + 1}</b></span>
                    </div>
                    <div className='right-heading-dispostion'>
                        {asset?.isValid ? '' : <span className="error-reason me-2">Asset is  required</span>}
                        <EventHandler onEvent={() => onClickDelete(asset)} data-attribute="Reactivations_Default_EventHandler">
                            <img src={deleteOrder} alt='Delete Order' className='me-2' />
                        </EventHandler>
                    </div>
                </div>
            ),
            content: <>
                <Row>
                    <div className='Reactivations'>
                        <div className='Reactivations_descriptions'>
                            <Col xs={12} md={4} lg={6} className='mt-0 mb-3'>
                                <AssetNumber
                                    order={asset}
                                    setOrder={setAssetDetailList}
                                    addToCart={isAddAssetClicked}
                                    setAddToCart={setIsAddAssetClicked}
                                    setIsAsserNumberValid={setIsAsserNumberValid}
                                    assetDetailList={assetDetailList}
                                    setIsAssetBtnClicked={setIsAssetBtnClicked}
                                    isAssetBtnClicked={isAssetBtnClicked}
                                    AssetType={CONSTANTS.REACTIVATION}
                                //inputRef={(element: any) => DispositionAssetFieldRef.current[0] = element}
                                />
                            </Col>
                            {asset?.glCategory !== CONSTANTS.TRAILERS &&
                                <Col xs={12} md={4} lg={6} className='mb-3'>
                                    <Label required data-attribute="Reactivations_Default_Label">{getOdometerLabel(asset)}</Label>
                                    <InputField
                                        name='odometerHourMeter'
                                        value={asset?.odometerHourMeter}
                                        onChange={(item: any) => { onChangeOdometerHourMeter(item, asset) }}
                                        onBlur={(event: any) => { onBlurOdometerHourMeter(event, asset) }}
                                        onKeyPress={(event: any) => { 
                                            isHourMeterField(asset) 
                                                ? isNumberWithoutDecimal(event) 
                                                : isNumberWithOneDecimal(event) 
                                        }}
                                        className={(asset?.odometerHourMeterError?.length ? "controlValidation" : "")}
                                     data-attribute="Reactivations_odometerHourMeter_Input" />
                                    {asset?.odometerHourMeterError ? <p className='validMessage'>{asset?.odometerHourMeterError}</p> : ""}
                                </Col>
                            }
                            <Col xs={12} md={4} lg={6} className='mb-3'>
                                <Label data-attribute="Reactivations_Default_Label_2">Color</Label>
                                <InputField
                                    name='color'
                                    value={asset?.color}
                                    onChange={(item: any) => { onChangeColor(item, asset) }}
                                    className={(asset?.reactivationColorError?.length ? "controlValidation" : "")}
                                 data-attribute="Reactivations_color_Input" />
                                {asset?.reactivationColorError ? <p className='validMessage'>{asset?.reactivationColorError}</p> : ""}
                            </Col>
                            <Col xs={12} md={4} lg={6} className='mb-3'>
                                <Label data-attribute="Reactivations_Default_Label_3">Current License Plate #</Label>
                                <InputField
                                    name='currentLicensePlateNo'
                                    value={asset?.currentLicensePlateNo}
                                    onChange={(item: any) => { handleLicensePlateChange(item, asset) }}
                                    className={(asset?.currentLicensePlateError?.length ? "controlValidation" : "")}
                                 data-attribute="Reactivations_currentLicensePlateNo_Input" />
                                {asset?.currentLicensePlateError ? <p className='validMessage'>{asset?.currentLicensePlateError}</p> : ""}
                            </Col>
                        </div>
                        <Col xs={12} sm={12} md={12} lg={24} className='mb-3 mb-sm-2 reactivationdescriptionbox'>
                            <div className="asset-information-block">
                                <Label data-attribute="Reactivations_Default_Label_4">Asset Information</Label>
                                <div className="link-to-attachment">
                                    <EventHandler onEvent={(e: any) => { onClicktLinkAttachment(e, index) }} data-attribute="Reactivations_Default_EventHandler_2">
                                        <span id={"link_attachment_" + index}
                                            className={`link-attachment me-0 mb-2 ${asset?.attachmentsError?.length ? 'link-attachment-error' : ''}`}
                                        >
                                            <span className='fa fa-paperclip attachment-img'> </span> Link Attachment to Item ({getLinkedAttachmentsCount(asset)})
                                        </span>
                                    </EventHandler>
                                    <span className="required">*</span>
                                    {isAttachmentBtnClicked?.[index] && (
                                        <Callout
                                            targetId={"link_attachment_" + index}
                                            toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, index) }}
                                            calloutMaxHeight={300}
                                         data-attribute="Reactivations_Default_Callout">
                                            <GetAttachmentView
                                                attachmentsList={docList}
                                                onCloseLinkAttachment={onCloseLinkAttachment}
                                                onChangeLinkAttachment={onChangeLinkAttachment}
                                                itemType={asset} />
                                        </Callout>
                                    )}
                                </div>
                            </div>
                            <div className="asset-info-section mt-0">
                                <Row>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Unit#" value={(asset?.unitNumber != null && asset?.unitNumber?.trim()?.length != 0) ? asset?.unitNumber : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Description" value={(asset?.description != null && asset?.description?.trim()?.length != 0) ? asset?.description : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Equipment Status" value={(asset?.eqStatusDesc != null && asset?.eqStatusDesc?.trim()?.length != 0) ? asset?.eqStatusDesc : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Disp Cost Center" value={(asset?.costCenterNo != null && asset?.costCenterNo?.trim()?.length != 0) ? asset?.costCenterNo : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Dispose Date" value={(asset?.dateDisposed != null && asset?.dateDisposed?.toString()?.trim()?.length != 0) ? asset?.dateDisposed : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Year" value={(asset?.modelYear != null && asset?.modelYear?.trim()?.length != 0) ? asset?.modelYear : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Make" value={(asset?.manufacturerName != null && asset?.manufacturerName?.trim()?.length != 0) ? asset?.manufacturerName : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Model" value={(asset?.model != null && asset?.model?.trim()?.length != 0) ? asset?.model : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label={getVinSerialLabel(asset)} value={(asset?.serialNumber != null && asset?.serialNumber?.trim()?.length != 0) ? asset?.serialNumber : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="License Plate #" value={(asset?.licensePlateNumber != null && asset?.licensePlateNumber?.trim()?.length != 0) ? asset?.licensePlateNumber : '-'} />
                                    </Col>
                                    <Col xs={12} sm={3} md={3} lg={3} className='mb-0'>
                                        <InformativeField label="Gain / Loss" value={asset?.disposeGainLoss != null ? asset?.disposeGainLoss?.toString().includes('-') ? '$ (' + (formatPrice(asset?.disposeGainLoss, 2)) + ')' : `$ ${formatPrice(asset?.disposeGainLoss, 2)}` : '-'} />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={24} className="mb-3 mb-sm-2 comments_section">
                            <Label className="mt-2" required data-attribute="Reactivations_Default_Label_5">Comments</Label>
                            <InputField
                                name='comments'
                                value={asset?.reactivationComments}
                                onChange={(item: any) => { handleCommentchanges(item, asset) }}
                                className={(asset?.reactivationCommentsError?.length ? "controlValidation" : "")}
                            //inputRef={(element: any) => ReactivationAssetFieldRef.current[3] = element}
                             data-attribute="Reactivations_comments_Input" />
                            {asset?.reactivationCommentsError ? <p className='validMessage'>{asset?.reactivationCommentsError}</p> : ""}
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={8}
                            className={`mb-3 mb-sm-2 ${asset.attachmentsError?.length ? "validMessage mt-0" : "attachments-info"}`}
                        >
                            <Label className="mt-2" data-attribute="Reactivations_Default_Label_6">Attachments Required:</Label>
                            <div className="mx-3">
                                <ul
                                    className={asset.attachmentsError?.length ? "validMessage mt-0" : "attachments-info"}
                                >
                                    <li>Photos of asset to show its current condition</li>
                                    <li>Photo of asset serial number/VIN and asset ID</li>
                                    <li>Photo of odometer/hours, if applicable</li>
                                    <li>Documents submitted with disposal, if applicable</li>
                                </ul>
                            </div>
                        </Col>
                    </div>
                </Row>
            </>,
            uuid: `receivingBranch_${index}`,
            key: asset?.assetIndex
        };
        childItems.push(childItem);
    });

    //sorting child items(reasons) as last in first out order
    const sortedChildItemsLIFO = childItems?.sort((a: any, b: any) => b?.key - a?.key)

    return (
        <div className="item-details-requisition disposition mt-3 mb-3">
            <Card data-attribute="Reactivations_Default_Card">
                <div className='header border-bottom'>
                    <div className="left-content">
                        <p className='headingText'>ASSET INFORMATION <span>({assetDetailList?.length})</span></p>
                        <p className='subText enter-asset'>Enter Asset #</p>
                    </div>
                    <div className="right-content">
                        <div className="asset-qty asset-qty-disposition">
                            <EventHandler onEvent={(item: any) => onClickAdd(item)} data-attribute="Reactivations_Default_EventHandler_3">
                                <img className="add-asset-button-plus" src={plus} alt="add asset" />
                            </EventHandler>
                            <div
                                className={`attachment-container ms-2 mt-0`}
                            >
                                <div className="pull-right">
                                    <AttachmentCommonUpload
                                        link={true}
                                        list={documentList}
                                        uploadedList={docList}
                                        setList={setDocumentList}
                                        multiple={true}
                                        uploadBtnClick={onUploadClick}
                                        error={attachmentError}
                                        setError={setAttachmentError}
                                        maxSize={5}
                                        onRemove={onRemoveAttachment}
                                        isAttachmentsRequired
                                        tooltipConent={ATTACHMENTS_TOOLTIP_CONTENT}
                                        iAttachmentEditable={true}
                                        isDownloadable={false}
                                        disabled={!isAuthorized(permissions.CreateUpdateTransfers)}
                                     data-attribute="Reactivations_Default_AttachmentCommonUpload" />
                                </div>
                            </div>
                        </div>
                        {/* {dispositionData?.assetDispositionChoiseAttatmentNote ? <p className='note-diposition-msg attachments'><span>Note - </span>{dispositionData?.assetDispositionChoiseAttatmentNote}</p> : dispositionData?.uploadAttachmentsError && <p className='validMessage'>{dispositionData?.uploadAttachmentsError}</p>} */}
                    </div>
                    {
                        addNewAssetAlert &&
                        <Alert
                            className="alert-message warningAlert"
                            showAlert={addNewAssetAlert}
                            dismissAlert={hideDialogAsset}
                            type="warning"
                            text="New Asset Quantity added."
                         data-attribute="Reactivations_Default_Alerts" />
                    }
                </div>
                <Accordion
                    Items={sortedChildItemsLIFO}
                    className="item-detail-accordion asset-information-accordion"
                    preExpanded={[`receivingBranch_0`]}
                 data-attribute="Reactivations_Default_Accordion" />
                <Row>
                    <Col xs={12} md={12} lg={24} className="transfer-asset-content pull-right">
                        <div className='cancel-edit-btn reactivation'>
                            {
                                (isEditOrder || transferOrderByIdData?.orderStatus?.includes('Pending Approval')) && <PrimaryButton className='ml-2 ' text='Revert Changes' onClick={() => { revertChangesOnClick() }}
                                // btnRef={(element: any) => ReactivationAssetFieldRef.current[4] = element}
                                disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}
                                 data-attribute="Reactivations_Default_Button" />
                            }
                            {
                                (isEditOrder || transferOrderByIdData?.orderStatus?.includes('Pending Approval')) && <OutlineButton text='Cancel Request' onClick={() => { cancelRequestOnClick() }} disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}  data-attribute="Reactivations_Default_Button_2" />
                            }
                        </div>
                        <PrimaryButton text={(showCart && reactivationAssets?.length) ? "Update to Cart" : 'Add to Cart'} onClick={onClickAddAsset} disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Reactivations_Default_Button_3" />
                    </Col>
                </Row>
            </Card>
            {Popupcontent.isDialogVisible ? <CompleteConfirmationPopup
                hideDialog={!Popupcontent.isDialogVisible}
                onDismiss={hideDialog}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
            /> : ""}
            {WarningPopupcontent.isDialogVisible ?
                <CancelConfirmationPopup
                    hideDialog={!WarningPopupcontent.isDialogVisible}
                    onDismiss={warningHideDialog}
                    Popupcontent={WarningPopupcontent}
                    popupOutlinebtnOnclick={() => WarningPopupcontent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={() => WarningPopupcontent.popupPrimarybtnOnclick()}
                    className='penalty-warning-popup'
                /> : ""}
            {cancelPopupContent.isDialogVisible ?
                <PopupDialogbox
                    hideDialog={!cancelPopupContent.isDialogVisible}
                    onDismiss={hideCancelDialog}
                    Popupcontent={cancelPopupContent}
                    popupOutlinebtnOnclick={cancelPopupContent?.popupOutlinebtnOnclick}
                    popupPrimarybtnOnclick={(
                        item: any,
                        actionby: string,
                        value: any
                    ) => {
                        cancelPopupContent?.popupPrimarybtnOnclick(
                            item,
                            actionby,
                            value
                        );
                    }}
                 data-attribute="Reactivations_Default_PopupDilalogBox" /> : ""}
        </div>
    )

}

export default Reactivations;
